require('./style.less');


var Marionette = require('marionette');


// For now now doing collection view ... if leave that way may was well do collection
module.exports = Marionette.ItemView.extend({

    template: require('./template.hbs'),

    serializeData: function() {

        return {
            inputs: this.options.inputCollection.toJSON()
        };

    }



});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/views/note/textStamp/variableInputs/view.js
 ** module id = 328
 ** module chunks = 0
 **/